import { getJson, postJson } from 'utils/http';

type ApplicantNotificationData = {
  listingApplication: {
    id: string;
    listing: {
      id: string;
      type: 'JOB' | 'VOLOP' | 'INTERNSHIP';
      name: string;
    };
    status: 'NEW';
    newCount: number;
  };
};
type MentionNotificationData = {
  listingApplication: {
    id: string;
    mentionBy: {
      id: string;
      name: string;
      email: string;
    };
    listing: {
      id: string;
      type: 'JOB' | 'VOLOP' | 'INTERNSHIP';
      name: string;
    };
    status: 'NEW';
    newCount: number;
  };
};
type ApplicantsByListingNotification = {
  type: 'NEW_APPLICATIONS_BY_LISTING';
  created: string;
  data: {
    id: string;
    applications: Array<{
      id: string;
      notificationId: string;
    }>;
    type: 'JOB' | 'VOLOP' | 'INTERNSHIP';
    name: string;
    orgId: string;
    status: 'NEW';
    count: number;
    newCount: number;
  };
};
type MentionsByApplicationNotification = {
  type: 'NEW_MENTIONS_BY_APPLICATION';
  created: string;
  data: {
    id: string;
    listing: {
      id: string;
      type: 'JOB' | 'VOLOP' | 'INTERNSHIP';
      name: string;
    };
    mentionBy: {
      id: string;
      name: string;
      email: string;
    };
    mentions: Array<{
      id: string;
      notificationId: string;
    }>;
    type: 'JOB' | 'VOLOP' | 'INTERNSHIP';
    orgId: string;
    status: 'NEW';
    count: number;
  };
};
export type Notification =
  | {
      id: string;
      created: string;
      type: 'NEW_LISTING_APPLICATION' | 'MENTION_LISTING_APPLICATION';
      about: {
        id: string;
        type: 'ORG';
      };
      data: ApplicantNotificationData | MentionNotificationData;
    }
  | ApplicantsByListingNotification
  | MentionsByApplicationNotification;
export type Notifications = Array<Notification>;
export const fetchNotifications = (): Promise<Array<Notification>> =>
  getJson('/data/notifications').then(({ notifications }) => notifications);
export const dismissNotifications = (notificationIds: Array<string>) =>
  postJson('/data/notifications-read', {
    notificationIds,
  }).then(({ notifications }) => notifications);
